import { CSVData } from 'utils/csv-util'
import SearchableJob from 'jobs/SearchableJob'
import { ColumnId, exportValue } from './JobsTableColumns'

interface ExportableColumnDetails {
  id: ColumnId
  header: string
  visible: boolean
}

/**
 * Jobs Export Adapter.
 */
export function JobsExportAdapter(
  getAllFilteredJobs: () => Promise<SearchableJob[]>,
  getFilteredColumns: () => ExportableColumnDetails[],
) {
  return {
    /**
     * Returns array containing jobs data organized for CSV exporting.
     */
    jobsExportData: async () => {
      const jobs = await getAllFilteredJobs()
      const columns = getFilteredColumns()

      // Insert Job ID column after Job Short ID column.
      columns.splice(2, 0, {
        id: ColumnId.JobId,
        header: 'Job ID',
        visible: true,
      })

      const header: CSVData = [
        columns
          .filter((column) => column.visible)
          .map((column) =>
            // The short ID is labeled as "Job ID" in the UI.
            column.id === ColumnId.JobShortId ? 'Job Short ID' : column.header,
          )
          .concat('Job specs'),
      ]
      const data: CSVData = jobs.map((job) =>
        columns
          .filter((column) => column.visible)
          .map((column) => exportValue(column.id, job))
          .concat(job.jobScopeItems.join(', ')),
      )

      return header.concat(data)
    },
  }
}
